module.exports = __webpack_public_path__ + "assets/img/title-d9e192e8.png";